import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormControl } from '@angular/forms';
import { debounceTime, startWith } from 'rxjs/operators';

import { PerfilesService } from '@services/perfiles/perfiles.service';
import { PreviousRouteService } from '@services/shared/previous-route.service';

interface AdminItem {
    title: string;
    desc: string;
    icon: string;
    color: string;
    route: string;
    terms?: string;
}

@Component({
    selector: 'app-push-administracion',
    templateUrl: './push-administracion.component.html',
    styleUrls: ['./push-administracion.component.scss'],
})
export class PushAdministracionComponent implements OnInit {
    routes: { url: string; label: string }[] = [{ url: '/', label: 'Inicio' }];

    searchCtrl = new FormControl('');

    items: AdminItem[] = [
        {
            title: 'Enviar Push',
            desc: 'Enviar notificaciones push individuales, masivas o por plan',
            icon: 'fas fa-paper-plane',
            color: '#580f2e', // 🔥 color Signo
            route: '/push',
        },
        {
            title: 'Historial Push',
            desc: 'Ver historial, estado de envíos y métricas de notificaciones',
            icon: 'fas fa-history',
            color: '#8e44ad',
            route: '/push-history',
        },
    ].map((x) => ({ ...x, terms: norm(`${x.title} ${x.desc}`) }));

    filtered: AdminItem[] = [];

    constructor(
        private router: Router,
        private perfilesService: PerfilesService,
        private previousRouteService: PreviousRouteService,
    ) {}

    ngOnInit(): void {
        this.perfilesService.allowedByUserLogon(this.router.url);

        this.previousRouteService.getRoutes().subscribe((routes) => {
            this.routes = routes;
        });

        this.filtered = [...this.items];

        this.searchCtrl.valueChanges
            .pipe(startWith(''), debounceTime(120))
            .subscribe((q) => {
                const query = norm(q || '');
                if (!query) {
                    this.filtered = this.items;
                    return;
                }

                this.filtered = this.items.filter((x) =>
                    x.terms!.includes(query),
                );
            });
    }

    trackByTitle(index: number, item: AdminItem): string {
        return item.title;
    }
}

/* ===== utils ===== */

function norm(s: string): string {
    return (s || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/\p{Diacritic}/gu, '')
        .trim();
}
